<template>
  <div class="main home">
    <div class="banner" @click="openExternalLink(dzImage)">
      <img :src="dzImage.piclink" alt="" />
    </div>
    <div>
      <van-button type="info" block @click="openExternalLink(topLink)">
        {{ topLink.description }}
      </van-button>
    </div>
    <div style="padding: 10px 0; font-size: 12px">
      <div v-html="topTitle.content"></div>
    </div>

    <div class="box2">
      <ul>
        <li class="clearfloat" @click="isStop('考试报名入口', toApply)">
          <img class="icon" src="../assets/icon04.png" alt="" />考试报名入口<img
            class="right"
            src="../assets/icon01.png"
            alt=""
          />
        </li>

        <li class="clearfloat" @click="isStop('考试确认', showExamConfirm)">
          <img class="icon" src="../assets/icon02.png" alt="" />
          考试确认<img class="right" src="../assets/icon01.png" alt="" />
        </li>

        <li class="clearfloat" @click="isStop('下载报名信息表', downloadDz)">
          <img class="icon" src="../assets/icon02.png" alt="" />
          下载报名信息表<img class="right" src="../assets/icon01.png" alt="" />
        </li>

        <li class="clearfloat" @click="isStop('准考证下载入口', download)">
          <img
            class="icon"
            src="../assets/icon02.png"
            alt=""
          />准考证下载入口<img
            class="right"
            src="../assets/icon01.png"
            alt=""
          />
        </li>
        <li
          class="clearfloat"
          @click="isStop('资格审核及成绩查询入口', toResult)"
        >
          <img
            class="icon"
            src="../assets/icon03.png"
            alt=""
          />资格审核及成绩查询入口<img
            class="right"
            src="../assets/icon01.png"
            alt=""
          />
        </li>

        <!-- <li class="clearfloat" @click="doPdf">
          <img class="icon" src="../assets/icon03.png" alt="" />pdf入口<img
            class="right"
            src="../assets/icon01.png"
            alt=""
          />
        </li> -->
      </ul>
    </div>

    <div class="bottom">
      <div v-html="bottomTitle.content"></div>
    </div>

    <van-popup
      v-model="examShow"
      :style="{ width: '80%', 'max-height': '800px' }"
      round
    >
      <div style="padding: 40px 20px 10px">
        <div v-html="examConfirmText.content"></div>
      </div>
      <div class="popup_btn">
        <div @click="examShow = false">取消</div>
        <div @click="examConfirm">确认</div>
      </div>
    </van-popup>

    <div
      class="indexDz_flex_image"
      @click="
        cityShow = true;
        cityRadio = cityItem;
      "
    >
      <div>
        城市：<span>{{ cityItem.title }}</span>
      </div>
    </div>

    <van-popup
      v-model="cityShow"
      position="bottom"
      closeable
      class="city-select-popup"
      close-icon-position="top-right"
    >
      <div class="city-popup-content">
        <div class="city-popup-title">开放报名城市</div>
        <van-radio-group v-model="cityRadio" class="city-radio-group">
          <div
            @click="cityRadio = item"
            v-for="(item, index) in cityDz"
            :key="index"
            class="city-radio-item"
          >
            <div class="city-item-text">
              {{ item.title }}
              <span class="enroll-tag" v-if="item.is_apply == 1">(已报名)</span>
            </div>
            <van-radio slot="right-icon" :name="item" />
          </div>
        </van-radio-group>
        <div class="city-confirm-btn" @click="onConfirmCity">确认</div>
      </div>
    </van-popup>
    <textPdf
      style="position: absolute; left: -9999px; top: -9999px; z-index: -1"
      ref="textPdf"
      :info="info"
      :formList="formList"
      :examItem="examItem"
      :formListShow="formListShow"
    ></textPdf>
  </div>
</template>

<script>
import textPdf from "@/components/textPdf";
import { Toast, Dialog, Popup, Icon } from "vant";
export default {
  name: "hello",
  components: {
    Popup,
    Icon,
    textPdf,
  },
  data() {
    return {
      // 获取文章
      topLink: {},
      topTitle: {},
      bottomTitle: {},
      dzImage: {},

      //考试确认
      examShow: false,
      examConfirmText: {},

      // 报考城市
      cityDz: [],
      cityItem: {},
      cityRadio: {},
      cityShow: false,

      // 报名信息
      info: {},

      examItem: {},
      formListShow: false,
      formList: [
        {
          key: "bachelor_degree",
          label: "本科",
          yx: "",
          zy: "",
          xw: "",
        },
        {
          key: "graduate_degrees",
          label: "研究生",
          yx: "",
          zy: "",
          xw: "",
        },
        {
          key: "doctoral_degrees",
          label: "博士",
          yx: "",
          zy: "",
          xw: "",
        },
      ],
    };
  },
  computed: {},
  watch: {
    $route() {},
  },
  methods: {
    openExternalLink(item) {
      let val = item.link;
      if (val.indexOf("http:") >= 0 || val.indexOf("https:") >= 0) {
        // 外部链接地址
        const externalUrl = val;
        // 新标签页打开
        // window.open(externalUrl, "_blank");
        // 若需在当前标签页打开，替换为：
        window.location.href = externalUrl;
      } else {
        this.$router.push({ path: "/newsInfo?id=" + item.id });
      }
    },
    doPdf() {
      // this.$refs.textPdf.generatePdf("imgCard", "准考证下载");
      this.$refs.textPdf.generatePdf("imgCard2", "考生报名信息表");
    },
    getContent(id, key) {
      this.$api.getUser.get_agreement({ id: id }).then((res) => {
        if (res.code == 200) {
          this[key] = res.result;
        } else {
          this.$toast.fail(res.result);
        }
      });
    },
    // 报名信息
    getDetail() {
      return new Promise((resolve, reject) => {
        this.$api.getDz
          .getUserFormDetail({ city: this.$store.state.cityId })
          .then((res) => {
            try {
              if (Object.keys(res.result).length > 0) {
                this.info = { ...res.result };
                this.formList.forEach((item, index) => {
                  let key = item.key;
                  if (this.info[key]) {
                    this.formListShow = index;
                    let parts = this.info[key].split("@");
                    item.yx = parts[0].replace("院校：", "");
                    item.zy = parts[1].replace("专业：", "");
                    item.xw = parts[2].replace("学位：", "");
                  }
                });
                let examStatus = this.info.status || "";
                switch (examStatus) {
                  case "1":
                    this.examItem = {};
                    this.examItem.show_pass_number =
                      this.info.written_pass_number || "";
                    this.examItem.show_exam_name =
                      this.info.written_exam_name || "";
                    this.examItem.show_exam_add =
                      this.info.written_exam_add || "";
                    this.examItem.show_exam_number =
                      this.info.written_exam_number || "";
                    this.examItem.show_seat_number =
                      this.info.written_seat_number || "";
                    this.examItem.show_exam_time =
                      this.info.written_exam_time || "";
                    break;

                  case "2":
                    this.examItem = {};
                    this.examItem.show_pass_number =
                      this.info.ac_pass_number || "";
                    this.examItem.show_exam_name = this.info.ac_exam_name || "";
                    this.examItem.show_exam_add = this.info.ac_exam_add || "";
                    this.examItem.show_exam_number =
                      this.info.ac_exam_number || "";
                    this.examItem.show_seat_number = this.info.ac_number || "";
                    this.examItem.show_exam_time = this.info.ac_exam_time || "";
                    break;

                  case "3":
                    this.examItem = {};
                    this.examItem.show_pass_number =
                      this.info.interview_pass_number || "";
                    this.examItem.show_exam_name =
                      this.info.interview_exam_name || "";
                    this.examItem.show_exam_add =
                      this.info.interview_exam_add || "";
                    this.examItem.show_exam_number =
                      this.info.interview_exam_number || "";
                    this.examItem.show_seat_number =
                      this.info.interview_number || "";
                    this.examItem.show_exam_time =
                      this.info.interview_exam_time || "";
                    break;

                  default:
                    this.examItem = {};
                    break;
                }
              } else {
                this.$toast("您未报名");
              }
              resolve(res);
            } catch (error) {
              console.log(error);
            }
          });
      });
    },
    // 报考城市
    getCity() {
      this.$api.getDz.page_city().then((res) => {
        if (res.code == 200) {
          this.cityDz = [];
          const formatDate = (timeStr) => {
            // 处理空值/非法值
            if (!timeStr) return "未设置";

            let date;
            // 兼容时间戳（数字/字符串）
            if (/^\d+$/.test(timeStr)) {
              // 若时间戳是10位（秒），转13位（毫秒）
              const timestamp =
                timeStr.length === 10
                  ? Number(timeStr) * 1000
                  : Number(timeStr);
              date = new Date(timestamp);
            } else {
              // 兼容 YYYY-MM-DD / YYYY/MM/DD 等字符串
              date = new Date(timeStr);
            }

            // 校验日期是否有效
            if (isNaN(date.getTime())) return "时间格式错误";

            // 格式化：年-月-日（可自定义格式）
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0"); // 补零
            const day = String(date.getDate()).padStart(2, "0"); // 补零

            // 可选格式：YYYY年MM月DD日 / YYYY-MM-DD
            return `${year}年${month}月${day}日`;
            // 若需要短格式：return `${year}-${month}-${day}`;
          };
          let n = res.result;
          n.forEach((i) => {
            const startDate = formatDate(i.bm_start_time);
            const endDate = formatDate(i.bm_end_time);
            i.title_2 = `${i.title}（${startDate}~${endDate}）`;
            if (i.show == 1) {
              this.cityDz.push(i);
            }
          });
          let cityId = this.$store.state.cityId;
          let m = this.cityDz.findIndex((item) => {
            return item.id == cityId;
          });
          if (cityId != "" && m > 0) {
            this.cityItem = this.cityDz[m];
          } else {
            this.cityItem = this.cityDz[0];
            this.$store.commit("setCityId", this.cityItem.id);
          }
        }
      });
    },
    onConfirmCity() {
      this.cityItem = this.cityRadio;
      this.$store.commit("setCityId", this.cityItem.id);
      this.cityShow = false;
    },

    //总操作
    isStop(key, fnc, id) {
      if (!this.$store.state.isLogin) {
        this.$router.push({ path: "/login" });
        return;
      }
      this.$api.getDz.enroll_entrance().then((res) => {
        if (res.code == 200) {
          let entrance = res.result || [];
          if (entrance[key] && entrance[key] != false) {
            fnc();
          } else {
            Dialog.alert({
              title: "入口暂未开放",
            });
          }
        }
      });
    },
    // 考试报名入口
    toApply() {
      let m = this.cityDz.findIndex((item) => {
        return (
          item.id != this.cityItem.id &&
          item.bm_start_time == this.cityItem.bm_start_time &&
          item.bm_end_time == this.cityItem.bm_end_time &&
          item.is_apply == 1
        );
      });
      if (m != -1) {
        Dialog.alert({
          title: "您已存在相同时间段的报名记录，不可重复报名",
        });
      } else {
        this.$store.commit("setRedirect", "/applyform");
        this.$router.push("/applyform");
      }
    },
    // 考试确认
    showExamConfirm() {
      this.getDetail().then((res) => {
        this.info = { ...res.result };
        if (!this.info.id) {
          this.infoIdNull();
          return;
        }
        if (this.info.first_instance != 1) {
          this.judgmentStatus();
          return;
        }
        if (this.info.exam == 1) {
          Dialog.alert({
            title: "您已成功确认考试，请按照公告要求完成后续考试流程。",
          });
        } else {
          this.examShow = true;
        }
      });
    },
    examConfirm() {
      this.$api.getDz.enroll_change_exam({ id: this.info.id }).then((res) => {
        if (res.code == 200) {
          this.$toast.success("成功");
          this.examShow = false;
        }
      });
    },
    // 下载报名信息表
    downloadDz() {
      this.$store.commit("setRedirect", "");
      this.getDetail().then((res) => {
        this.info = { ...res.result };
        if (!this.info.id) {
          this.infoIdNull();
          return;
        }
        if (this.info.first_instance != 1) {
          this.judgmentStatus();
          return;
        }
        if (this.info.exam == 1) {
          this.$refs.textPdf.generatePdf("imgCard2", "考生报名信息表");
        } else {
          Dialog.alert({
            title: "请先进行考试确认",
          });
        }
      });
    },
    // 准考证下载入口
    download() {
      this.$store.commit("setRedirect", "");
      this.getDetail().then((res) => {
        this.info = { ...res.result };
        if (!this.info.id) {
          this.infoIdNull();
          return;
        }
        if (this.info.first_instance != 1) {
          this.judgmentStatus();
          return;
        }
        if (this.info.download == 1) {
          this.$nextTick(() => {
            this.$refs.textPdf.generatePdf("imgCard", "准考证下载");
          });
        } else {
          Dialog.alert({
            title: "请联系客服",
          });
        }
      });
    },
    // 资格审核及成绩查询入口
    toResult() {
      this.$store.commit("setRedirect", "/result");
      this.$router.push("/result");
    },

    judgmentStatus() {
      let msg = "";
      switch (this.info.first_instance) {
        case 0:
          msg = "系统初审审核中";
          break;
        case 2:
          msg = "系统初审不通过";
          break;
        case 3:
          msg = "系统初审资料不齐";
          break;
        default:
          msg =
            "系统初审状态 ：" + this.info.first_instance + "，请截图联系客服";
          break;
      }
      Dialog.alert({
        title: msg,
      });
    },
    infoIdNull() {
      Dialog.alert({
        title: "无报名信息，请确认城市信息是否正确",
      });
    },
  },
  created() {
    this.getContent(5470, "topLink");
    this.getContent(5471, "topTitle");
    this.getContent(5472, "bottomTitle");
    this.getContent(5476, "dzImage");
    this.getContent(5478, "examConfirmText");
  },
  computed: {},
  mounted() {
    this.getCity();
  },
};
</script>

<style lang="less">
html,
body {
  background-color: #fafafa;
}

.home {
  position: relative;
}
.home .banner img {
  width: 100%;
}

.home .bottom {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0.62rem;
  text-align: center;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
}

.home .box2 {
  padding: 12px 16px;
  box-sizing: border-box;
}

.home .box2 li {
  text-align: left;
  padding: 12px;
  box-sizing: border-box;
  background: #fff;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 32px;
  position: relative;
  margin-bottom: 16px;
}

.home .box2 li .icon {
  width: 32px;
  height: 32px;
  float: left;
  margin-right: 12px;
}

.home .box2 li .right {
  width: 0.12rem;
  height: 0.22rem;
  position: absolute;
  right: 0.43rem;
  top: 50%;
  margin-top: -0.11rem;
}
.popup_btn {
  display: flex;
  > div {
    padding: 20px;
    flex: 1;
    font-size: 16px;
    color: #323233;
  }
  > div:nth-child(2) {
    color: #1989fa;
  }
}

.indexDz_flex_image {
  /* 原有基础定位 */
  position: absolute;
  right: 20px;
  bottom: 100px;
  padding: 10px 15px;
  z-index: 5;
  border-radius: 8px; /* 圆形样式，更符合悬浮元素设计 */
  background-color: #fff; /* 白色背景，避免透明穿透 */
  box-shadow: 0 2px 10px rgba(64, 158, 255, 0.5); /* 轻微阴影，提升层次感 */
}

/* 弹窗整体样式 */
.city-select-popup {
  --van-popup-background: #fff;
  --van-popup-border-radius: 16px 16px 0 0; /* 顶部圆角 */
  padding-bottom: 0; /* 去掉默认内边距，自定义 */
}

/* 弹窗内容容器 */
.city-popup-content {
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  min-height: 200px;
}

/* 标题样式 */
.city-popup-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

/* 单选组容器 */
.city-radio-group {
  flex: 1; /* 占满中间空间 */
  margin-bottom: 24px;
}

/* 单个城市选项 */
.city-radio-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid #f5f5f5; /* 分隔线 */
  cursor: pointer;
  touch-action: manipulation; /* 优化移动端点击 */
}

/* 城市文字区域 */
.city-item-text {
  font-size: 16px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px; /* 文字和标签间距 */
}

/* 已报名标签 */
.enroll-tag {
  font-size: 12px;
  color: #1989fa; /* 绿色突出已报名 */
  background: #f0f9ff;
  padding: 2px 8px;
  border-radius: 12px;
}

/* 确认按钮 */
.city-confirm-btn {
  width: 100%;
  height: 48px;
  line-height: 48px;
  text-align: center;
  background: #1989fa; /* 绿色主按钮 */
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  margin-top: 10px;
  touch-action: manipulation;
}

/* 按钮点击态 */
.city-confirm-btn:active {
  background: #1989fa;
  opacity: 0.9;
}
.van-dialog__header--isolated {
  padding: 25px;
}
</style>
